"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = exports.Hint = exports.Label = exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var typography_1 = require("../../../typography");
var VerticalSpacer_1 = __importDefault(require("../../../utils/VerticalSpacer"));
exports.Wrapper = styled_components_1.default(VerticalSpacer_1.default).attrs({
    amount: { small: 6, medium: 8, large: 8 },
})(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.Label = styled_components_1.default.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n"], ["\n  display: inline-block;\n"])));
exports.Hint = styled_components_1.default(typography_1.Body).attrs({ level: '4', color: 'GREY_70' })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-top: 0.35em;\n"], ["\n  margin-top: 0.35em;\n"])));
exports.Error = styled_components_1.default(typography_1.Body).attrs({ level: '4', color: 'RED_50' })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 0.35em;\n"], ["\n  margin-top: 0.35em;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
